import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/styles/pdp.css");
;
import(/* webpackMode: "eager", webpackExports: ["InventoryDetails"] */ "/app/views/Inventory/InventoryDetails/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpDisableHeader"] */ "/app/views/Inventory/Pdp/PdpDisableHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpForm"] */ "/app/views/Inventory/Pdp/PdpForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageActions"] */ "/app/views/Inventory/Pdp/PdpImages/ImageActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpImageSlider"] */ "/app/views/Inventory/Pdp/PdpImages/PdpImageSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopCta"] */ "/app/views/Inventory/Pdp/PdpInfo/DesktopCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdpSimilarRVsSlider"] */ "/app/views/Inventory/Pdp/PdpSimilarRVs/PdpSimilarRVsSlider.tsx");
